import POPIAcceptanceBox from "../Partials/POPIAcceptanceBox";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import axios from "axios";
import { urlbase } from "../../constants/Constants";
import "./Styling.css";
import { TextField, Box, Button } from "@mui/material";
import { registerUser } from "../../api/admin";
import UpdatePasswordSMSSent from "../Partials/SMSSentPopup";
import { s3BaseUrl } from "../../config/envConfig";

export default function RegisterPage1() {
  const history = useHistory();

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    dob: "",
    gender: "",
    contact: "",
    role: "",
    level: "",
    grade: "",
    school_id: "",
  });

  const [formErrors, setFormErrors] = useState({
    first_name: false,
    last_name: false,
    dob: false,
    school_id: false,
    role: false,
    level: false,
    grade: false,
    gender: false,
    contact: false,
  });

  const [formValid, setFormValid] = useState(false);
  const [showError, setShowError] = useState(false);
  const [schools, setSchools] = useState([]);
  const [levels, setLevels] = useState([]);

  const [grades] = useState(["8", "9", "10", "11", "12"]);
  const [genders] = useState(["Male", "Female", "Other"]);
  const [roles] = useState(["Student", "Teacher"]);
  const [teachers] = useState(["FET", "SP", "Other"]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [showPopiBox, setShowPopiBox] = useState(false);
  const [showUpdatePasswordSMS, setShowUpdatePasswordSMS] = useState(false);

  const currentDate = new Date();
  const minDate = new Date(
    currentDate.getFullYear() - 13,
    currentDate.getMonth(),
    currentDate.getDate()
  );
  const minDateString = minDate.toISOString().split("T")[0];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(urlbase().concat("search_schools"));
        const unsortedSchools = response?.data;
        if (unsortedSchools !== undefined) {
          setSchools(
            unsortedSchools.sort((a, b) =>
              a.name.toLowerCase().trim() < b.name.toLowerCase().trim() ? -1 : 1
            )
          );
        }
      } catch (error) {
        console.error("Error fetching schools:", error);
      }
    };

    fetchData();
  }, []);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleInputChange = (key, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [key]: value,
    }));
    if (key === "role") {
      setLevels(
        value === "Student" ? grades : value === "Teacher" ? teachers : []
      );
    }
  };

  const validateField = (key, value) => {
    let isValid = value.length !== 0;
    if (key === "contact") {
      isValid = isValid && value.length === 10 && /^\d+$/.test(value);
    }
    return isValid;
  };

  const handleBlur = (key, value) => {
    const isValid = validateField(key, value);
    setFormErrors((prevState) => ({
      ...prevState,
      [key]: !isValid,
    }));
  };

  const handleSubmit = () => {
    if (isSubmitting) return;

    setIsSubmitting(true);
    console.log("Submit button clicked");

    const newFormErrors = {
      ...formErrors,
      contact: !validateField("contact", formData.contact),
    };

    console.log("Form errors:", newFormErrors);

    setFormErrors(newFormErrors);

    const isValid = Object.values(newFormErrors).every((error) => !error);
    console.log("Form valid:", isValid);

    if (isValid) {
      setFormValid(true);
      setShowPopiBox(true);
      setShowError(false);
    } else {
      setFormValid(false);
      setShowPopiBox(false);
      setShowError(true);
    }

    setIsSubmitting(false);
  };

  useEffect(() => {
    const isValid = Object.values(formErrors).every((error) => !error);
    setFormValid(isValid);
  }, [formErrors]);

  function getSchool() {
    return (
      schools.find((x) => x.name === formData.school_id) || { id: 0, name: "" }
    );
  }

  function POPIDecline() {
    setShowPopiBox(false);
  }

  async function handlePOPIAccept() {
    const sch = getSchool();
    try {
      const response = await registerUser(
        formData.first_name,
        formData.last_name,
        new Date(formData.dob),
        sch.id,
        formData.grade ? formData.grade : formData.level,
        formData.gender,
        formData.contact,
        true
      );

      if (response.code === 200) {
        setShowUpdatePasswordSMS(true);
        console.log("Navigating to Register Page 2");
      } else {
        console.error("Error registering user:", response.message);
      }
    } catch (error) {
      console.error("Error registering user:", error);
    }
  }

  function handleSmsClose() {
    setShowUpdatePasswordSMS(false);
    history.push("/login");
  }

  return (
    <>
      <div>
        <POPIAcceptanceBox
          display={showPopiBox}
          handler={POPIDecline}
          handler2={handlePOPIAccept}
        />
        <UpdatePasswordSMSSent
          display={showUpdatePasswordSMS}
          handler={handleSmsClose}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: windowWidth >= 800 ? "50%" : "80%",
          }}
        >
          <div className="logoBackground">
            <div>
              <img
                src={
                  s3BaseUrl + "/mobitutorza_logo_full.png"
                }
                alt={"MobiTutorZA Logo"}
                width={"250px"}
                height={"250px"}
              />
            </div>

            <div>
              <p
                style={{
                  color: "white",
                  fontSize: "1.25em",
                  fontWeight: "bold",
                }}
              >
                Registration
              </p>
              <hr
                style={{ color: "white", width: "100%", marginBottom: "20px" }}
              />
              <div className="popi">
                <p className="p">
                  This registration is done in accordance with the POPI Act and
                  must be done in the presence of your parent/guardian if you
                  are under the age of 18.
                </p>
                <p className="p">
                  The username you enter will be displayed on the leader board
                  (and visible to others). Please DO NOT use sensitive,
                  identifiable information like email addresses or phone
                  numbers.
                </p>
              </div>
            </div>

            <Box
              component="form"
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
              }}
              noValidate
              autoComplete="off"
            >
              <TextField
                sx={{
                  backgroundColor: "rgba(224, 224, 224, 0.12)",
                  borderRadius: "5px",
                  "& .MuiInputBase-input": {
                    padding: "15px 14px",
                    fontSize: "0.875rem",
                    color: "white",
                  },
                  "&.Mui-focused": {
                    borderColor: "#00112e",
                    "--joy-palette-primary-500": "#01ACC7",
                  },
                  width: "100%",
                }}
                InputProps={{
                  sx: {
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#FBCD02",
                    },
                  },
                }}
                InputLabelProps={{
                  sx: {
                    color: "white",
                    "&.Mui-focused": {
                      color: "#FBCD02",
                    },
                  },
                }}
                error={formErrors.first_name}
                helperText={
                  formErrors.first_name ? "First Name is required" : ""
                }
                label="First Name"
                variant="outlined"
                onChange={(e) =>
                  handleInputChange("first_name", e.target.value)
                }
                onBlur={(e) => handleBlur("first_name", e.target.value)}
              />
              <TextField
                sx={{
                  backgroundColor: "rgba(224, 224, 224, 0.12)",
                  borderRadius: "5px",
                  "& .MuiInputBase-input": {
                    padding: "15px 14px",
                    fontSize: "0.875rem",
                    color: "white",
                  },
                  "&.Mui-focused": {
                    borderColor: "#00112e",
                    "--joy-palette-primary-500": "#01ACC7",
                  },
                  width: "100%",
                }}
                InputProps={{
                  sx: {
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#FBCD02",
                    },
                  },
                }}
                InputLabelProps={{
                  sx: {
                    color: "white",
                    "&.Mui-focused": {
                      color: "#FBCD02",
                    },
                  },
                }}
                error={formErrors.last_name}
                helperText={formErrors.last_name ? "Last Name is required" : ""}
                label="Last Name"
                variant="outlined"
                onChange={(e) => handleInputChange("last_name", e.target.value)}
                onBlur={(e) => handleBlur("last_name", e.target.value)}
              />
              <TextField
                sx={{
                  backgroundColor: "rgba(224, 224, 224, 0.12)",
                  borderRadius: "5px",
                  "& .MuiInputBase-input": {
                    padding: "15px 14px",
                    fontSize: "0.875rem",
                    color: "white",
                  },
                  "&.Mui-focused": {
                    borderColor: "#00112e",
                    "--joy-palette-primary-500": "#01ACC7",
                  },
                  width: "100%",
                }}
                InputProps={{
                  sx: {
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#FBCD02",
                    },
                  },
                  inputProps: {
                    max: minDateString,
                  },
                }}
                InputLabelProps={{
                  sx: {
                    color: "white",
                    "&.Mui-focused": {
                      color: "#FBCD02",
                    },
                  },
                }}
                error={formErrors.dob}
                helperText={formErrors.dob ? "Date of Birth is required" : ""}
                variant="outlined"
                type="date"
                onChange={(e) => handleInputChange("dob", e.target.value)}
                onBlur={(e) => handleBlur("dob", e.target.value)}
              />
              <TextField
                sx={{
                  backgroundColor: "rgba(224, 224, 224, 0.12)",
                  borderRadius: "5px",
                  "& .MuiInputBase-input": {
                    padding: "15px 14px",
                    fontSize: "0.875rem",
                    color: "white",
                  },
                  "&.Mui-focused": {
                    borderColor: "#00112e",
                    "--joy-palette-primary-500": "#01ACC7",
                  },
                  width: "100%",
                }}
                InputProps={{
                  sx: {
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#FBCD02",
                    },
                  },
                }}
                InputLabelProps={{
                  sx: {
                    color: "white",
                    "&.Mui-focused": {
                      color: "#FBCD02",
                    },
                  },
                }}
                error={formErrors.gender}
                helperText={formErrors.gender ? "Gender is required" : ""}
                label="Gender"
                variant="outlined"
                select
                SelectProps={{
                  native: true,
                }}
                onChange={(e) => handleInputChange("gender", e.target.value)}
                onBlur={(e) => handleBlur("gender", e.target.value)}
              >
                <option aria-label="None" value="" />
                {genders.map((gender) => (
                  <option key={gender} value={gender}>
                    {gender}
                  </option>
                ))}
              </TextField>
              <TextField
                sx={{
                  backgroundColor: "rgba(224, 224, 224, 0.12)",
                  borderRadius: "5px",
                  "& .MuiInputBase-input": {
                    padding: "15px 14px",
                    fontSize: "0.875rem",
                    color: "white",
                  },
                  "&.Mui-focused": {
                    borderColor: "#00112e",
                    "--joy-palette-primary-500": "#01ACC7",
                  },
                  width: "100%",
                }}
                InputProps={{
                  sx: {
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#FBCD02",
                    },
                  },
                }}
                InputLabelProps={{
                  sx: {
                    color: "white",
                    "&.Mui-focused": {
                      color: "#FBCD02",
                    },
                  },
                }}
                error={formErrors.contact}
                helperText={
                  formErrors.contact
                    ? "Contact Number is required and must be 10 digits"
                    : ""
                }
                label="Contact Number"
                variant="outlined"
                onChange={(e) => handleInputChange("contact", e.target.value)}
                onBlur={(e) => handleBlur("contact", e.target.value)}
              />
              <TextField
                sx={{
                  backgroundColor: "rgba(224, 224, 224, 0.12)",
                  borderRadius: "5px",
                  "& .MuiInputBase-input": {
                    padding: "15px 14px",
                    fontSize: "0.875rem",
                    color: "white",
                  },
                  "&.Mui-focused": {
                    borderColor: "#00112e",
                    "--joy-palette-primary-500": "#01ACC7",
                  },
                  width: "100%",
                }}
                InputProps={{
                  sx: {
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#FBCD02",
                    },
                  },
                }}
                InputLabelProps={{
                  sx: {
                    color: "white",
                    "&.Mui-focused": {
                      color: "#FBCD02",
                    },
                  },
                }}
                error={formErrors.role}
                helperText={formErrors.role ? "Role is required" : ""}
                label="Role"
                variant="outlined"
                select
                SelectProps={{
                  native: true,
                }}
                onChange={(e) => handleInputChange("role", e.target.value)}
                onBlur={(e) => handleBlur("role", e.target.value)}
              >
                <option aria-label="None" value="" />
                {roles.map((role) => (
                  <option key={role} value={role}>
                    {role}
                  </option>
                ))}
              </TextField>
              <TextField
                sx={{
                  backgroundColor: "rgba(224, 224, 224, 0.12)",
                  borderRadius: "5px",
                  "& .MuiInputBase-input": {
                    padding: "15px 14px",
                    fontSize: "0.875rem",
                    color: "white",
                  },
                  "&.Mui-focused": {
                    borderColor: "#00112e",
                    "--joy-palette-primary-500": "#01ACC7",
                  },
                  width: "100%",
                }}
                InputProps={{
                  sx: {
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#FBCD02",
                    },
                  },
                }}
                InputLabelProps={{
                  sx: {
                    color: "white",
                    "&.Mui-focused": {
                      color: "#FBCD02",
                    },
                  },
                }}
                error={formErrors.grade}
                helperText={formErrors.grade ? "Grade/Level is required" : ""}
                label="Grade / Level"
                variant="outlined"
                select
                SelectProps={{
                  native: true,
                }}
                onChange={(e) => handleInputChange("grade", e.target.value)}
                onBlur={(e) => handleBlur("grade", e.target.value)}
              >
                <option aria-label="None" value="" />
                {levels.map((level) => (
                  <option key={level} value={level}>
                    {level}
                  </option>
                ))}
              </TextField>
              <TextField
                sx={{
                  backgroundColor: "rgba(224, 224, 224, 0.12)",
                  borderRadius: "5px",
                  "& .MuiInputBase-input": {
                    padding: "15px 14px",
                    fontSize: "0.875rem",
                    color: "white",
                  },
                  "&.Mui-focused": {
                    borderColor: "#00112e",
                    "--joy-palette-primary-500": "#01ACC7",
                  },
                  width: "100%",
                }}
                InputProps={{
                  sx: {
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#FBCD02",
                    },
                  },
                }}
                InputLabelProps={{
                  sx: {
                    color: "white",
                    "&.Mui-focused": {
                      color: "#FBCD02",
                    },
                  },
                }}
                error={formErrors.school_id}
                helperText={formErrors.school_id ? "School is required" : ""}
                label="School"
                variant="outlined"
                select
                SelectProps={{
                  native: true,
                }}
                onChange={(e) => handleInputChange("school_id", e.target.value)}
                onBlur={(e) => handleBlur("school_id", e.target.value)}
              >
                <option aria-label="None" value="" />
                {schools.map((school) => (
                  <option key={school.id} value={school.name}>
                    {school.name}
                  </option>
                ))}
              </TextField>
            </Box>

            {showError && (
              <div className="errorMessage">
                <p>Please make sure all fields are filled in correctly.</p>
              </div>
            )}

            <Button
              variant="contained"
              style={{
                marginTop: "20px",
                backgroundColor: "#fbcd02",
                color: "#00112e",
                width: "100%",
                height: "3.2em",
                fontWeight: "bold",
              }}
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              Next
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
